/**
 * Disable strict mode for Vuex as it can have an impac on performance.
 *
 * @see  https://github.com/nuxt/nuxt.js/issues/6279
 * @type {Boolean}
 */
// eslint-disable-next-line import/prefer-default-export
export const strict = false;
